<template>
  <div :class="$style.page">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="提交域名转入" name="first">
        <template v-if="activeName === 'first'">
          <EnterSubmit />
        </template>
      </el-tab-pane>
      <el-tab-pane label="域名转入记录" name="second">
        <template v-if="activeName === 'second'">
          <EnterRecord :type="type" />
        </template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import EnterSubmit from "./domain-enter/EnterSubmit.vue";
import EnterRecord from "./domain-enter/EnterRecord.vue";

export default {
  name: "DomainEnter",
  components: {
    EnterSubmit,
    EnterRecord,
  },
  data() {
    return {
      activeName: "first",
      type: 1,
    };
  },
  watch: {
    $route({ query }) {
      this.activeName = query.activeName || "first";
    },
  },
  methods: {
    handleClick() {
      const query =
        this.activeName === "first" ? {} : { activeName: this.activeName };
      this.$router.push({ path: "/user/domain-enter", query });
    },
  },
  created() {
    const { query } = this.$route;
    this.activeName = query.activeName || "first";
  },
  mounted() {
    if (this.$route.query.tab) {
      this.type = this.$route.query.tab;
    }
  },
};
</script>

<style lang="scss" module scoped>
.page {
  :global {
    ::v-deep .el-tabs {
      .el-tabs__content {
        min-height: 300px;
      }
    }
  }
}
</style>
